import { render, staticRenderFns } from "./productData.vue?vue&type=template&id=3bb8ee05&scoped=true&lang=pug&"
import script from "./productData.vue?vue&type=script&lang=js&"
export * from "./productData.vue?vue&type=script&lang=js&"
import style0 from "./productData.vue?vue&type=style&index=0&id=3bb8ee05&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb8ee05",
  null
  
)

export default component.exports